import {GetDocumentsIdsModel} from './get-documents-ids.model';

export class DocumentUploadModel {
  patientId: string;
  patientCaseId: string;

  // Deprecate
  blobXml: Blob;
  blob: Blob;
  blobThumbnail: Blob;
  // End Deprecate

  docClassId: string;
  docFileTypeId: string;
  docTypeId: string;
  docTagIds: string[];
  hasAnnotation: boolean;

  parentDocId: string;
  duplicateDocId: string;
  caseWorkItemToothIds: string[];
  caseWorkItemId: string;
  folderId: string;
  documentOrder: number = -1;
  thumbDocId: string;
  isSaveAsNew: boolean = true;

  // Change after offsetting binary blob upload to frontend
  BlobInfo: GetDocumentsIdsModel;

  // Use for imaging-calibration
  deviceId: string;

  // Use for file created date
  createDate: string;
  description: string ='';
}
